import { post } from '../base'

export const reportEventMiniProgram = (params: Record<string, unknown>) => {
  return post('/stat/mark', params, { requestConfig: { needEncrypt: true } })
}
